import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    language: localStorage.getItem('language') || 'pt',
    weightUnit: localStorage.getItem('weightUnit') || 'kg',
    heightUnit: localStorage.getItem('heightUnit') || 'm',
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isTransparent: '',
    isRTL: false,
    mcolor: '',
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    apiToken: null,
    redeMarketingJwt: null,
    redeMarketingMembroId: null,
    redeMarketingCodigoIndicacao: null,
    coachManager: null,
    studentManager: null,
    trainingPlanManager: null,
    loaderScreen: false,
    userType: null,
    lastTimeLogged: '',
    userLogged: null,
    requiresSubscription: false,
    series: [],
    copyExercises: [],
  },
  mutations: {
    SET_LANGUAGE(state, language) {
      state.language = language
    },
    SET_WEIGHT_UNIT(state, weightUnit) {
      state.weightUnit = weightUnit
    },
    SET_HEIGHT_UNIT(state, heightUnit) {
      state.heightUnit = heightUnit
    },
    SET_SERIES(state, status) {
      state.series = status
    },
    SET_COPY_EXERCISES(state, status) {
      state.copyExercises = status
    },
    SET_SPLASH_SCREEN(state, status) {
      state.loaderScreen = status
    },
    SET_USER_TYPE(state, status) {
      state.userType = status
    },
    SET_REQUIRES_SUBSCRIPTION(state, value) {
      state.requiresSubscription = !!value
    },
    SET_API_TOKEN(state, token) {
      state.apiToken = token
    },
    SET_REDE_MARKETING_AUTH(state, { jwt, membroId, codigoIndicacao }) {
      state.redeMarketingJwt = jwt
      state.redeMarketingMembroId = membroId
      state.redeMarketingCodigoIndicacao = codigoIndicacao
    },
    SET_TIME_LOGIN(state) {
      let data = new Date()
      state.lastTimeLogged = data.getTime()
    },
    SET_LOGOUT(state) {
      state.userLogged = null
      state.apiToken = null
      state.redeMarketingJwt = null
      state.redeMarketingMembroId = null
      state.redeMarketingCodigoIndicacao = null
      state.userType = null
      state.trainingPlanManager = null
      state.studentManager = null
      state.coachManager = null
      state.requiresSubscription = false
      localStorage.removeItem('vuex')
      localStorage.removeItem('pse')
      localStorage.removeItem('psr')
      state.series = null
      state.series = []
      state.copyExercises = null
      state.copyExercises = []
      // state.userPermission = []
    },
    SET_COACH(state, token) {
      state.coachManager = token
    },
    SET_USER_LOGIN(state, obj) {
      state.userLogged = obj
    },
    SET_STUDENT(state, token) {
      state.studentManager = token
    },
    SET_TRAINING_PLAN(state, token) {
      state.trainingPlanManager = token
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector('.g-sidenav-show')

      if (sidenav_show.classList.contains('g-sidenav-hidden')) {
        sidenav_show.classList.remove('g-sidenav-hidden')
        sidenav_show.classList.add('g-sidenav-pinned')
        state.isPinned = true
      } else {
        sidenav_show.classList.add('g-sidenav-hidden')
        sidenav_show.classList.remove('g-sidenav-pinned')
        state.isPinned = false
      }
    },
    sidebarType(state, payload) {
      state.isTransparent = payload
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true
      } else {
        state.isNavFixed = false
      }
    },
  },
  actions: {
    updateLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    updateWeightUnit({ commit }, weightUnit) {
      commit('SET_WEIGHT_UNIT', weightUnit)
    },
    updateHeightUnit({ commit }, heightUnit) {
      commit('SET_HEIGHT_UNIT', heightUnit)
    },
    toggleSidebarColor({ commit }, payload) {
      commit('sidebarType', payload)
    },
    handleUpdateToken({ commit }, payload) {
      commit('SET_API_TOKEN', payload)
      commit('SET_TIME_LOGIN', payload)
    },
    handleLogout({ commit }, payload) {
      commit('SET_API_TOKEN', payload)
    },
  },
  getters: {
    ApiToken: (state) => state.apiToken,
    RedeMarketingJwt: (state) => state.redeMarketingJwt,
    RedeMarketingMembroId: (state) => state.redeMarketingMembroId,
    RedeMarketingCodigoIndicacao: (state) => state.redeMarketingCodigoIndicacao,
    language: (state) => state.language,
    weightUnit: (state) => state.weightUnit,
    heightUnit: (state) => state.heightUnit,
    CoachManager: (state) => state.coachManager,
    StudentManager: (state) => state.studentManager,
    TrainingPlanManager: (state) => state.trainingPlanManager,
    splashScreen: (state) => state.loaderScreen,
    UserType: (state) => state.userType,
    RequiresSubscription: (state) => state.requiresSubscription,
    getLastTimeLogged: (state) => state.lastTimeLogged,
    LoggedUser: (state) => state.userLogged,
    getSeries: (state) => state.series,
    getCopyExercises: (state) => state.copyExercises,
  },
  plugins: [createPersistedState()],
})
